import { render, staticRenderFns } from "./ISAStatcallsCount.vue?vue&type=template&id=76dc872c&scoped=true&"
import script from "./ISAStatcallsCount.vue?vue&type=script&lang=js&"
export * from "./ISAStatcallsCount.vue?vue&type=script&lang=js&"
import style0 from "./ISAStatcallsCount.vue?vue&type=style&index=0&id=76dc872c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dc872c",
  null
  
)

export default component.exports